import { FunctionComponent, PropsWithChildren, useRef, useState } from 'react';
import ChevronDownIcon from '../../icons/ChevronDown';
import ChevronUp from '../../icons/ChevronUp';
type ReadMoreProps = {
  heightClass?: string;
  borderClass?: string;
  colorClass?: string;
  gradientClass?: string;
  chevronColorClass?: string;
  bgClass?: string;
};
const ReadMore: FunctionComponent<PropsWithChildren<ReadMoreProps>> = ({
  heightClass,
  borderClass,
  colorClass,
  gradientClass,
  chevronColorClass,
  bgClass,
  children,
}) => {
  heightClass = heightClass || 'max-h-40';
  borderClass = borderClass || 'border-read-more-text';
  colorClass = colorClass || 'text-read-more-text';
  gradientClass = gradientClass || 'bg-whiteGradient';
  chevronColorClass = chevronColorClass || 'stroke-primaryDark';
  bgClass = bgClass || 'bg-white';
  const [isOpen, setIsOpen] = useState(false);
  const topOfContentRef = useRef<HTMLDivElement>(null);

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      topOfContentRef.current?.scrollIntoView(true);
    }
  };
  const content = useRef<string>(
    (children as any)?.props?.children?.props?.html,
  );
  if (content.current && content.current.length <= 400) {
    return <>{children}</>;
  }
  return (
    <>
      <section
        ref={topOfContentRef}
        className={`${
          isOpen ? 'max-h-full' : heightClass
        } overflow-hidden relative min-h-[8rem]`}
      >
        {children}
        <section
          className={`${
            isOpen ? 'relative' : 'absolute'
          }  ease-in-out duration-300 bottom-0 w-full p-2 ${gradientClass}  h-20 flex flex-col justify-end`}
        >
          <button
            onClick={() => {
              toggleIsOpen();
            }}
            className={`rounded-full ${bgClass} border-2 ${borderClass} ${colorClass} font-base  mx-auto px-4 flex`}
          >
            {isOpen ? (
              <>
                Read Less&nbsp;
                <ChevronUp className={`h-6 w-6 ${chevronColorClass}`} />
              </>
            ) : (
              <>
                {' '}
                Read More&nbsp;
                <ChevronDownIcon
                  className={`w-6 h-6 stroke-purple ${chevronColorClass}`}
                />
              </>
            )}
          </button>
        </section>
      </section>
    </>
  );
};

export default ReadMore;
